<template>
  <div class="CompanyPrivilege">
    <div class="inner_center">
      <h2>企业VIP特权</h2>
      <div class="subhead">包含线上用途版、全用途版用户</div>

      <div class="privilege-box">
        <div
          v-for="vo in PRIVILEGE_LIST"
          :key="vo.title + 'privilege'"
          class="privilege-item "
        >
          <div class="img-box" :class="vo.imgBgClass">
            <div class="icon-box">
              <i class="icon_common" :class="vo.iconClass"></i>
            </div>
          </div>
          <div class="title">{{ vo.title }}</div>
          <div class="desc">{{ vo.desc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

const PRIVILEGE_LIST = [
  {
    title: '独家正版潮流内容',
    desc: '全站高质量内容独家版权',
    iconClass: 'qi01',
    imgBgClass: 'intro1'
  },
  {
    title: '授权证书在线获取',
    desc: '在线生成授权书，可下载到本地',
    iconClass: 'qi02',
    imgBgClass: 'intro2'
  },
  {
    title: '侵权赔付保障',
    desc: '会员期内下载作品，永久商用保障，无惧侵权',
    iconClass: 'qi03',
    imgBgClass: 'intro3'
  },
  {
    title: '企业VRF授权协议',
    desc: '企业VIP在会员期间内享受企业商用授权服务',
    iconClass: 'qi04',
    imgBgClass: 'intro4'
  },
  {
    title: '线上电子发票',
    desc: '为企业提供增值税电子发票，在线申请，报销无忧',
    iconClass: 'qi05',
    imgBgClass: 'intro5'
  },
  {
    title: '专属服务1对1',
    desc: '企业VIP专属客服快速响应，随时为您解决各类问题',
    iconClass: 'qi06',
    imgBgClass: 'intro6'
  },

]
export default {
  name: "CompanyPrivilege",
  data() {
    return {
      PRIVILEGE_LIST
    }
  }
}
</script>

<style lang="scss" scoped>

@mixin PrivilegeImgBg($url) {
  @include BgImage(348px, 228px, 'introduce/company/privilege/#{$url}.png');
}

@mixin PrivilegeIconBg($url) {
  @include BgImage(34px, 34px, 'introduce/company/privilege/#{$url}.png');
}

.CompanyPrivilege {
  //height: 923px;
  background: #FFFFFF;

  .inner_center {
    width: 1200px !important;

    h2 {
      font-size: 36px;
      font-weight: bold;
      color: #2D2B33;
      line-height: 48px;
      letter-spacing: 1px;
      padding-top: 64px;
      text-align: center;
    }

    .subhead {
      font-size: 16px;
      color: #2D2B33;
      line-height: 21px;
      letter-spacing: 1px;
      margin: 4px 0 64px;
      text-align: center;
    }

    .privilege-box {
      display: flex;
      flex-wrap: wrap;
      padding-bottom: 16px;


      .privilege-item {
        width: 348px;
        margin-right: 78px;
        margin-bottom: 56px;
        text-align: center;

        &:nth-child(3n) {
          margin-right: 0;
        }


        .img-box {
          width: 100%;
          position: relative;

          &.intro1 {
            @include PrivilegeImgBg('intro1')
          }

          &.intro2 {
            @include PrivilegeImgBg('intro2')
          }

          &.intro3 {
            @include PrivilegeImgBg('intro3')
          }

          &.intro4 {
            @include PrivilegeImgBg('intro4')
          }

          &.intro5 {
            @include PrivilegeImgBg('intro5')
          }

          &.intro6 {
            @include PrivilegeImgBg('intro6')
          }

          .icon-box{
            display: inline-block;
            width: 56px;
            height: 56px;
            @include Position(1, 4, 50%, -20px);
            transform: translateX(-50%);
            background-color: #FFFFFF;
            border-radius: 50%;
            @include LayoutFlex(1);

            .icon_common {

              &.qi01 {
                @include PrivilegeIconBg(qi01);
              }

              &.qi02 {
                @include PrivilegeIconBg(qi02);
              }

              &.qi03 {
                @include PrivilegeIconBg(qi03);
              }

              &.qi04 {
                @include PrivilegeIconBg(qi04);
              }

              &.qi05 {
                @include PrivilegeIconBg(qi05);
              }

              &.qi06 {
                @include PrivilegeIconBg(qi06);
              }

            }
          }





        }

        .title{
          margin: 22px 0 4px;
          font-size: 18px;
          font-weight: bold;
          color: #0A2540;
          line-height: 24px;
        }

        .desc{
          font-size: 14px;
          color: #596088;
          line-height: 19px;
        }


      }


    }
  }
}
</style>
